import { ref } from "vue";

const STORAGE_KEY = "kanban-board-first-visit";

export function useFirstTimeUser() {
  // Check localStorage immediately (synchronously)
  const visited = localStorage.getItem(STORAGE_KEY);
  const isFirstVisit = ref(!visited);
  const hasSeenInstructions = ref(!visited); // Show instructions immediately if first visit

  const markAsVisited = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    isFirstVisit.value = false;
    hasSeenInstructions.value = false;
  };

  const showInstructions = () => {
    hasSeenInstructions.value = true;
  };

  const hideInstructions = () => {
    hasSeenInstructions.value = false;
  };

  const resetFirstVisit = () => {
    localStorage.removeItem(STORAGE_KEY);
    isFirstVisit.value = true;
    hasSeenInstructions.value = true; // Show instructions when resetting
  };

  return {
    isFirstVisit,
    hasSeenInstructions,
    markAsVisited,
    showInstructions,
    hideInstructions,
    resetFirstVisit,
  };
}
